<!-- 
Panel for showing notice attachments.
-->
<template>
  <div>
    <v-btn 
      flat small 
      class="ml-0 mt-0 mr-1" color="primary" 
      @click="show"
    >
      Show attachment
      <our-expand-icon :expanded="showing"/>
    </v-btn>
    <v-btn 
      flat small class="ml-0 mt-0" color="primary"
      target="_blank" 
      @click.stop="download"
    >
      Show attachment in new window
      <v-icon small class="ml-2">open_in_new</v-icon>
    </v-btn>
    <div v-if="showing" class="dropdown mt-3">
      <div style="position:relative">
        <v-progress-circular
          indeterminate
          color="primary"
          style="position:absolute;z-index:1;"
        />
      </div>
      <embed
        v-if="attachmentUrl"
        :src="attachmentUrl"
        type="application/pdf" width="100%" height="600"
        style="position:relative;z-index:2;"
      >
    </div>
  </div>
</template>

<script>
import { tableHelper } from "@/helpers/table.helper";

export default {
  props: {
    attachmentName: {
      type: String,
      default: null
    },
    noticeId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      attachmentUrl: "",
      showing: false
    };
  },
  watch: {
    attachmentName() {
      this.refresh();
    },
    noticeId() {
      this.refresh();
    }
  },
  methods: {
    load() {
      this.attachmentUrl = `/api/notices/attachment/${this.noticeId}/pdf`;
    },
    async show() {
      this.showing = !this.showing;
      if (this.showing) {
        await this.load();
      } else {
        this.attachmentUrl = "";
      }
    },
    download() {
      const url = `/api/notices/attachment/${this.noticeId}/pdf`;
      tableHelper.openInNewWindow(url);
    },
    async refresh() {
      if (this.showing) {
        this.load();
      }
    }
  }
};
</script>
